export default __webpack_public_path__ + "static/media/why.251436f4.png";